module.exports = __webpack_public_path__ + "img/imiwin-support.9e2e1a9f.png";